import styled from 'styled-components'

import { Infos as GSInfos } from 'components/general-styles/General'
import { theme } from 'styles/theme'

const { colors, space, media } = theme

export const ContactUs = styled.section`
  position: relative;
  width: 100%;
  padding: ${space['spacing-xxxl']} 0;
  background-color: #f0f0f2;

  @media (${media.desktop}) {
    padding: ${space['spacing-giga']} 0;
  }
`

export const Infos = styled(GSInfos)`
  text-align: left;
`

export const CardsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-sm']};
  overflow-x: auto;
  margin-bottom: ${space['spacing-lg']};

  @media (${media.desktop}) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
`

export const CardContent = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  min-width: 300px;
  padding: ${space['spacing-md']} ${space['spacing-sm']};

  a {
    text-decoration: underline;
    text-decoration-color: ${colors['neutral-text-default']};
  }
`

export const IconImage = styled.div`
  width: 48px;
  margin: 0 0 ${space['spacing-md']};
`
